import React from "react";
import GalleryStyle from "../../../../assets/stylesheets/experience/sections/ExperienceGallery.module.css";

const LAVENDER_FALLBACK = "https://images.unsplash.com/photo-1499002238440-d264edd596ec?w=600&h=400&fit=crop";

export default function ExperienceGallery({ experience }) {
  const coverUrl = experience?.coverImage?.viewUrl || null;
  const galleryUrls = (experience?.galleryImages || [])
    .map((img) => img.viewUrl || img.url)
    .filter(Boolean);

  const raw = [coverUrl, ...galleryUrls].filter(Boolean);
  const allImages = Array.from({ length: 5 }, (_, i) => raw[i] ?? LAVENDER_FALLBACK);
  const title = experience?.title || "";
  const thumbClasses = ["thumb1", "thumb2", "thumb3", "thumb4"];

  return (
    <div>        <div className={GalleryStyle["gallery-grid"]}>
        <div className={GalleryStyle["gallery-item--large"]}>
          <img src={allImages[0]} alt={title} className={GalleryStyle["gallery-photo"]} />
        </div>
        {thumbClasses.map((thumbCls, i) => (
          <div key={i} className={`${GalleryStyle["gallery-thumb"]} ${GalleryStyle[thumbCls]}`}>
            <img
              src={allImages[i + 1]}
              alt={`${title} ${i + 2}`}
              className={GalleryStyle["gallery-photo"]}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
